export const breakpoints = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1536,
  xxxl: 1920
} as const;

export type BreakpointKey = keyof typeof breakpoints;

export const mediaQuery = {
  above(key: BreakpointKey): string {
    return `(min-width: ${breakpoints[key]}px)`;
  },
  below(key: BreakpointKey): string {
    return `(max-width: ${breakpoints[key] - 1}px)`;
  },
  between(min: BreakpointKey, max: BreakpointKey): string {
    return `(min-width: ${breakpoints[min]}px) and (max-width: ${breakpoints[max] - 1}px)`;
  }
};
